export default __webpack_public_path__ + "static/store-one.en-1128711aea4673cac78f3cabe0fbeb07.png";